import { arrayOf, bool, func, number, oneOf, shape, string } from 'prop-types';

export const PTButtonField = {
  value: number.isRequired,
  fadeClass: string,
  buttonLabel: string,
  buttonClassName: string,
  // currency not required for validation in case parameter is passed on the parent-component level
  currency: oneOf(['GBP', 'EUR']),
  onSubmit: func,
  description: string,
  descriptionTitle: string,
  isDisabled: bool,
  // isLoading feature in the styleguide doesn't play well with unmounting.
  // As a quick workaround, allow parent component to opt-out from loading.
  disableLoadingFeature: bool,
  changeFontSizeWithDesc: bool,
};

export const PTButtonFieldDefaults = {
  buttonLabel: 'Donate',
  buttonClassName: '',
  fadeClass: '',
  currency: null,
  description: null,
  descriptionTitle: '',
  isDisabled: false,
  form: null,
  onSubmit: () => {},
  disableLoadingFeature: false,
  changeFontSizeWithDesc: true,
};

export const PTButtonFieldFormContents = {
  buttonLabel: string,
  inputTitle: string,
  inputLabel: string,
  placeholder: string,
  inputValidators: arrayOf(func),
  inputParsers: arrayOf(func),
};

export const PTButtonFieldForm = {
  currency: oneOf(['GBP', 'EUR']).isRequired,
  form: shape(PTButtonFieldFormContents).isRequired,
  onSubmit: func,
  isDisabled: bool,
  // isLoading feature in the styleguide doesn't play well with unmounting.
  // As a quick workaround, allow parent component to opt-out from loading.
  disableLoadingFeature: bool,
  onSelectOption: func,
  selected: bool,
};

export const PTButtonFieldFormDefaults = {
  isDisabled: false,
  form: null,
  onSubmit: () => {},
  disableLoadingFeature: false,
  onSelectOption: () => {},
  selected: false,
};
